export class ImageContentReaderService {
	public async getImageDataUrl(file: File): Promise<ImageDataUrl> {
		const imageDataUrlString = await this.imageDataUrlString(file);

		return new ImageDataUrl(imageDataUrlString);
	}

	private imageDataUrlString(blob: Blob): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onloadend = () => resolve(reader.result as string);
			reader.onerror = () => reject(reader.error ?? new Error('Failed to read blob as a data URL'));
			reader.readAsDataURL(blob);
		});
	}
}

export class ImageDataUrl {
	constructor(imageDataUrl: string) {
		this.imageDataUrl = imageDataUrl;
	}

	private imageDataUrl: string;

	public get Basae64Content() {
		return this.imageDataUrl.split(',')[1];
	}

	public get DataUrlHead() {
		return this.imageDataUrl.split(',')[0];
	}
}
